import './restaurantList.scss';

export const RestaurantListComponent = {
    template: `
        <div id="restaurant-list-container">
            <restaurant-card ng-repeat="restaurant in $ctrl.data.restaurants" restaurant="restaurant" management-group-guid="$ctrl.data.guid"></restaurant-card>

            <div class="restaurant-list-message" ng-if="$ctrl.data.restaurants && $ctrl.data.restaurants.length === 0 && $ctrl.data.diningOptions.hasDelivery">
                No restaurants deliver to your location.
            </div>

            <div class="loader-container" ng-if="$ctrl.data.restaurantsLoading">
                <div class="loader"></div>
            </div>
        </div>
    `,
    controller: function($scope, consumerService, restaurantService) {
        'ngInject';
        const ctrl = this;
        ctrl.data = restaurantService.data;
        ctrl.consumerData = consumerService.data;
    }
};
